var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { useTheme } from "../ThemeProvider/ThemeProvider";
var getBgColor = function (color, colorGradient, selected) {
    if (selected) {
        return {
            default: "".concat(colorGradient[color].accentScale[8]),
        };
    }
    return {
        default: "".concat(colorGradient[color].accentScale[0]),
        hover: "".concat(colorGradient[color].accentScale[1]),
        active: "".concat(colorGradient[color].accentScale[2]),
    };
};
var getColor = function (color, colorGradient, selected) {
    if (selected) {
        return {
            default: "".concat(colorGradient[color].accentContrast),
        };
    }
    return {
        default: "".concat(colorGradient[color].accentScale[10]),
    };
};
var getPadding = function (size) {
    switch (size) {
        case "small":
            return "4px 8px";
        case "medium":
            return "8px 16px";
        case "large":
            return "12px 18px";
        default:
            return "8px 16px";
    }
};
var getIconSize = function (size) {
    switch (size) {
        case "small":
            return "16px";
        case "medium":
            return "20px";
        case "large":
            return "24px";
        default:
            return "20px";
    }
};
var getGap = function (size) {
    switch (size) {
        case "small":
            return "0.25rem";
        case "medium":
            return "0.5rem";
        case "large":
            return "0.5rem";
        default:
            return "0.5rem";
    }
};
var getOutlineFocus = function (color, colorGradient, selected) {
    return "2px solid ".concat(colorGradient[color].accentScale[7]);
};
var StyledToggleBtn = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: ", ";\n  font-size: 1rem;\n  width: 100%;\n  gap: ", ";\n  cursor: pointer;\n  color: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:focus-visible {\n    outline-offset: -2px;\n    outline: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n\n  & svg {\n    width: ", ";\n    height: ", ";\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: ", ";\n  font-size: 1rem;\n  width: 100%;\n  gap: ", ";\n  cursor: pointer;\n  color: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:focus-visible {\n    outline-offset: -2px;\n    outline: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n\n  & svg {\n    width: ", ";\n    height: ", ";\n  }\n"])), function (props) { return getPadding(props.$size); }, function (props) { return getGap(props.$size); }, function (props) {
    return getColor(props.$color, props.$colorGradient, props.$selected).default;
}, function (props) {
    return getBgColor(props.$color, props.$colorGradient, props.$selected).default;
}, function (props) {
    return getColor(props.$color, props.$colorGradient, props.$selected).default;
}, function (props) {
    return getOutlineFocus(props.$color, props.$colorGradient, props.$selected);
}, function (props) {
    return getBgColor(props.$color, props.$colorGradient, props.$selected).hover;
}, function (props) {
    return getBgColor(props.$color, props.$colorGradient, props.$selected).active;
}, function (props) { return getIconSize(props.$size); }, function (props) { return getIconSize(props.$size); });
var ToggleButton = function (_a) {
    var _b;
    var index = _a.index, children = _a.children, value = _a.value, defaultSelected = _a.defaultSelected, selected = _a.selected, _c = _a.color, color = _c === void 0 ? "primary" : _c, _d = _a.size, size = _d === void 0 ? "medium" : _d, className = _a.className, style = _a.style, 
    // Events
    onClick = _a.onClick;
    var colorPalette = useTheme().theme.colorPalette;
    var isSelected = (_b = selected !== null && selected !== void 0 ? selected : defaultSelected) !== null && _b !== void 0 ? _b : false;
    var _onClick = function (e) {
        onClick && onClick(e, value, index);
    };
    return (_jsx(StyledToggleBtn, __assign({ "$size": size, "$selected": isSelected, "$color": color, "$colorGradient": colorPalette, className: className, style: style, onClick: _onClick }, { children: children })));
};
ToggleButton.displayName = "ToggleButton";
export default ToggleButton;
var templateObject_1;
